import React, { useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";
import { useGetTemplatesQuery } from "../../../../../../services/api/production-order-template";

const ProductionOrderTemplateList = (props) => {
  const { searchQuery } = props;
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
    },
  ];

  const recordIdentifier = "name";

  const { data, isLoading } = useGetTemplatesQuery();

  return (
    <Box>
      <DataTable
        loading={isLoading}
        rows={data || []}
        columns={columns}
        recordIdentifier={recordIdentifier}
        actionIdentifier="production_order_template"
        isEnabledEdit={true}
        hasSeparateView={{ active: true, param: "id", suffix: "/view" }}
        search ={searchQuery}
      />
    </Box>
  );
};

export default ProductionOrderTemplateList;
